import styled from "styled-components";
import { Container } from "./Container";
import { Title } from "./Title";
import { spacing } from "@styling/sizing";

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x2}px;
`;

type PageContentProps = {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

export const PageContent = ({ title, actions, children }: PageContentProps) => {
  return (
    <Container>
      <PageHeader>
        <Title>{title}</Title>
        {actions && <ActionsContainer>{actions}</ActionsContainer>}
      </PageHeader>
      {children}
    </Container>
  );
};
